module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/mobile/1@2.png?989c4b65925ea352472753283c97f97b";